import { Check, Shield, Zap, Building2 } from 'lucide-react';
import { cn } from '../../../../utils/helpers';

const plans = [
  { name: 'Starter', price: '$49', desc: 'Perfect for small teams', features: ['Up to 5 members', 'Basic Analytics', 'Community Support'] },
  { name: 'Business Pro', price: '$149', desc: 'Our most popular plan', features: ['Unlimited members', 'Advanced Analytics', 'Priority Support', 'Custom Reports'], popular: true },
  { name: 'Enterprise', price: '$499', desc: 'For large scale operations', features: ['Dedicated Manager', 'SLA Guarantee', 'Custom Integration', 'White-labeling'] },
];

export default function Plans() {
  return (
    <div className="space-y-8 py-8">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold tracking-tight">Choose Your Plan</h1>
        <p className="text-neutral-500 dark:text-neutral-400 max-w-xl mx-auto">Scale your business with Messego's flexible subscription plans designed for every stage of growth.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {plans.map((plan) => (
          <div 
            key={plan.name} 
            className={cn(
              "bg-white dark:bg-neutral-900 p-8 rounded-[2.5rem] border-2 transition-all relative flex flex-col",
              plan.popular ? "border-neutral-900 shadow-2xl shadow-neutral-900/10 scale-105 z-10" : "border-neutral-100 dark:border-neutral-800 hover:border-neutral-200 dark:hover:border-neutral-800"
            )}
          >
            {plan.popular && (
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-neutral-900 text-white text-[10px] font-bold px-4 py-1 rounded-full uppercase tracking-widest">
                Most Popular
              </div>
            )}
            <div className="mb-8">
              <h3 className="text-xl font-bold mb-1">{plan.name}</h3>
              <p className="text-xs text-neutral-500 dark:text-neutral-400">{plan.desc}</p>
            </div>
            <div className="mb-8">
              <span className="text-4xl font-bold">{plan.price}</span>
              <span className="text-neutral-500 dark:text-neutral-400 text-sm">/month</span>
            </div>
            <ul className="space-y-4 mb-10 flex-1">
              {plan.features.map((feature) => (
                <li key={feature} className="flex items-center gap-3 text-sm text-neutral-600 dark:text-neutral-300">
                  <div className="w-5 h-5 rounded-full bg-neutral-50 dark:bg-neutral-950 flex items-center justify-center text-neutral-900 dark:text-neutral-50">
                    <Check className="w-3 h-3" />
                  </div>
                  {feature}
                </li>
              ))}
            </ul>
            <button className={cn(
              "w-full py-4 rounded-2xl font-bold transition-all",
              plan.popular ? "bg-neutral-900 text-white hover:bg-neutral-800 shadow-lg shadow-neutral-900/20" : "bg-neutral-100 dark:bg-neutral-800 text-neutral-900 dark:text-neutral-50 hover:bg-neutral-200 dark:hover:bg-neutral-800"
            )}>
              Select Plan
            </button>
          </div>
        ))}
      </div>

      <div className="flex flex-col md:flex-row items-center justify-center gap-8 pt-12">
        <div className="flex items-center gap-3 text-sm text-neutral-500 dark:text-neutral-400">
          <Shield className="w-5 h-5" />
          Secure checkout
        </div>
        <div className="flex items-center gap-3 text-sm text-neutral-500 dark:text-neutral-400">
          <Zap className="w-5 h-5" />
          Instant activation
        </div>
        <div className="flex items-center gap-3 text-sm text-neutral-500 dark:text-neutral-400">
          <Building2 className="w-5 h-5" />
          Enterprise ready
        </div>
      </div>
    </div>
  );
}
